import { useState, useEffect } from "react";

export default function Header({ toggleSidebar, isMobile }) {
  const [currentTime, setCurrentTime] = useState("");
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const [notifications, setNotifications] = useState(3);

  useEffect(() => {
    // تحديث الوقت الحالي
    const updateTime = () => {
      const now = new Date();
      const timeString = now.toLocaleTimeString("ar-SA", {
        hour: "2-digit",
        minute: "2-digit",
      });
      const dateString = now.toLocaleDateString("ar-SA", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
      setCurrentTime(`${timeString} - ${dateString}`);
    };

    updateTime();
    const interval = setInterval(updateTime, 60000);
    return () => clearInterval(interval);
  }, []);

  const handleLogout = () => {
    // هنا تضيف منطق تسجيل الخروج
    console.log("تسجيل الخروج");
    setUserMenuOpen(false);
  };

  const clearNotifications = () => {
    setNotifications(0);
    setUserMenuOpen(false);
  };

  return (
    <header className="header">
      {/* الجزء الأيمن: زر القائمة والعلامة التجارية */}
      <div className="header-left">
        {isMobile && (
          <button 
            className="menu-toggle"
            onClick={toggleSidebar}
            aria-label="فتح/إغلاق القائمة الجانبية"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M3 12H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              <path d="M3 6H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              <path d="M3 18H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
        )}
        
        <div className="brand">
          <div className="logo">
            <span className="logo-icon">🚀</span>
          </div>
          <div className="brand-text">
            <h1 className="app-name">لوحة تحكم الإدارة</h1>
            <p className="app-subtitle">نظام إدارة المحتوى المتكامل</p>
          </div>
        </div>
      </div>

      {/* الجزء الأيسر: الوقت والإشعارات والمستخدم */}
      <div className="header-right">
        {/* الوقت والتاريخ */}
        <div className="time-display">
          <span className="time-icon">🕐</span>
          <div className="time-text">
            <span className="time">{currentTime}</span>
          </div>
        </div>

        {/* إشعارات */}
        <div className="notifications">
          <button 
            className="notifications-btn"
            onClick={() => setNotifications(0)}
            aria-label="الإشعارات"
          >
            <span className="notifications-icon">🔔</span>
            {notifications > 0 && (
              <span className="notifications-badge">{notifications}</span>
            )}
          </button>
        </div>

        {/* ملف المستخدم */}
        <div className="user-menu-container">
          <button 
            className="user-btn"
            onClick={() => setUserMenuOpen(!userMenuOpen)}
            aria-label="فتح قائمة المستخدم"
          >
            <div className="user-avatar">
              <span className="avatar-text">أ</span>
            </div>
            <div className="user-info">
              <span className="user-name">أحمد محمد</span>
              <span className="user-role">مدير النظام</span>
            </div>
            <svg 
              className={`dropdown-arrow ${userMenuOpen ? "open" : ""}`} 
              width="16" 
              height="16" 
              viewBox="0 0 24 24"
            >
              <path d="M7 10l5 5 5-5z" fill="currentColor"/>
            </svg>
          </button>

          {/* قائمة المستخدم المنسدلة */}
          {userMenuOpen && (
            <div className="dropdown-menu">
              <div className="dropdown-header">
                <div className="dropdown-avatar">
                  <span className="avatar-text">أ</span>
                </div>
                <div className="dropdown-user-info">
                  <span className="dropdown-user-name">أحمد محمد</span>
                  <span className="dropdown-user-email">admin@example.com</span>
                </div>
              </div>
              
              <div className="dropdown-divider"></div>
              
              <button className="dropdown-item">
                <span className="dropdown-item-icon">👤</span>
                <span>الملف الشخصي</span>
              </button>
              
              <button className="dropdown-item">
                <span className="dropdown-item-icon">⚙️</span>
                <span>الإعدادات</span>
              </button>
              
              {notifications > 0 && (
                <button className="dropdown-item" onClick={clearNotifications}>
                  <span className="dropdown-item-icon">🔔</span>
                  <span>مسح الإشعارات ({notifications})</span>
                </button>
              )}
              
              <div className="dropdown-divider"></div>
              
              <button className="dropdown-item logout" onClick={handleLogout}>
                <span className="dropdown-item-icon">🚪</span>
                <span>تسجيل الخروج</span>
              </button>
            </div>
          )}
        </div>
      </div>

      {/* CSS داخل المكون */}
      <style jsx>{`
        .header {
          background: white;
          border-bottom: 1px solid #e2e8f0;
          padding: 0 24px;
          height: 70px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: sticky;
          top: 0;
          z-index: 1000;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
        }

        .header-left {
          display: flex;
          align-items: center;
          gap: 20px;
        }

        .menu-toggle {
          background: none;
          border: none;
          width: 40px;
          height: 40px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          color: #4a5568;
          transition: all 0.3s ease;
        }

        .menu-toggle:hover {
          background: #f7fafc;
          color: #2d3748;
        }

        .brand {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .logo {
          width: 40px;
          height: 40px;
          background: linear-gradient(135deg, #4299e1, #667eea);
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          color: white;
        }

        .brand-text {
          display: flex;
          flex-direction: column;
        }

        .app-name {
          margin: 0;
          font-size: 18px;
          font-weight: 700;
          color: #2d3748;
          line-height: 1.2;
        }

        .app-subtitle {
          margin: 0;
          font-size: 12px;
          color: #718096;
          line-height: 1.2;
        }

        .header-right {
          display: flex;
          align-items: center;
          gap: 20px;
        }

        .time-display {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 8px 12px;
          background: #f7fafc;
          border-radius: 8px;
          border: 1px solid #e2e8f0;
        }

        .time-icon {
          font-size: 16px;
        }

        .time-text {
          display: flex;
          flex-direction: column;
        }

        .time {
          font-size: 14px;
          font-weight: 500;
          color: #2d3748;
          white-space: nowrap;
        }

        .notifications {
          position: relative;
        }

        .notifications-btn {
          background: none;
          border: none;
          width: 40px;
          height: 40px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          color: #4a5568;
          position: relative;
          transition: all 0.3s ease;
        }

        .notifications-btn:hover {
          background: #f7fafc;
          color: #2d3748;
        }

        .notifications-icon {
          font-size: 20px;
        }

        .notifications-badge {
          position: absolute;
          top: -2px;
          right: -2px;
          background: #e53e3e;
          color: white;
          font-size: 10px;
          font-weight: 600;
          width: 18px;
          height: 18px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .user-menu-container {
          position: relative;
        }

        .user-btn {
          display: flex;
          align-items: center;
          gap: 12px;
          background: none;
          border: none;
          padding: 4px;
          border-radius: 12px;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .user-btn:hover {
          background: #f7fafc;
        }

        .user-avatar {
          width: 42px;
          height: 42px;
          background: linear-gradient(135deg, #48bb78, #38a169);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: 600;
          font-size: 18px;
        }

        .user-info {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        }

        .user-name {
          font-size: 14px;
          font-weight: 600;
          color: #2d3748;
        }

        .user-role {
          font-size: 12px;
          color: #718096;
        }

        .dropdown-arrow {
          transition: transform 0.3s ease;
        }

        .dropdown-arrow.open {
          transform: rotate(180deg);
        }

        .dropdown-menu {
          position: absolute;
          top: calc(100% + 10px);
          left: 0;
          background: white;
          border-radius: 12px;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
          width: 280px;
          z-index: 1000;
          border: 1px solid #e2e8f0;
          animation: slideDown 0.2s ease;
        }

        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .dropdown-header {
          padding: 16px;
          display: flex;
          align-items: center;
          gap: 12px;
          border-bottom: 1px solid #e2e8f0;
        }

        .dropdown-avatar {
          width: 50px;
          height: 50px;
          background: linear-gradient(135deg, #48bb78, #38a169);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: 600;
          font-size: 20px;
        }

        .dropdown-user-info {
          display: flex;
          flex-direction: column;
          flex: 1;
        }

        .dropdown-user-name {
          font-size: 16px;
          font-weight: 600;
          color: #2d3748;
        }

        .dropdown-user-email {
          font-size: 12px;
          color: #718096;
        }

        .dropdown-divider {
          height: 1px;
          background: #e2e8f0;
          margin: 8px 0;
        }

        .dropdown-item {
          display: flex;
          align-items: center;
          gap: 12px;
          width: 100%;
          padding: 12px 16px;
          background: none;
          border: none;
          text-align: right;
          cursor: pointer;
          color: #4a5568;
          font-size: 14px;
          transition: all 0.2s ease;
        }

        .dropdown-item:hover {
          background: #f7fafc;
          color: #2d3748;
        }

        .dropdown-item-icon {
          font-size: 18px;
          width: 24px;
        }

        .dropdown-item.logout {
          color: #e53e3e;
        }

        .dropdown-item.logout:hover {
          background: #fed7d7;
          color: #c53030;
        }

        /* Responsive Design */
        @media (max-width: 1024px) {
          .header {
            padding: 0 16px;
            height: 60px;
          }

          .time {
            font-size: 13px;
          }

          .app-name {
            font-size: 16px;
          }

          .dropdown-menu {
            left: auto;
            right: 0;
          }
        }

        @media (max-width: 768px) {
          .time-display {
            display: none;
          }

          .app-subtitle {
            display: none;
          }

          .user-info {
            display: none;
          }

          .dropdown-arrow {
            display: none;
          }

          .user-btn {
            padding: 0;
          }

          .menu-toggle {
            width: 36px;
            height: 36px;
          }
        }

        @media (max-width: 480px) {
          .header {
            padding: 0 12px;
          }

          .notifications-btn {
            width: 36px;
            height: 36px;
          }

          .user-avatar {
            width: 36px;
            height: 36px;
            font-size: 16px;
          }

          .logo {
            width: 36px;
            height: 36px;
            font-size: 18px;
          }

          .app-name {
            font-size: 14px;
          }

          .dropdown-menu {
            width: 250px;
          }
        }
      `}</style>
    </header>
  );
}